import type { Bundle } from '../types'

/** Matrice des règles pays. */
export const rules = {
  'rules.matrixTitle': { fr: 'Matrice activités × pays', en: 'Activities × countries matrix' },
  'rules.editHint': {
    fr: 'Cliquez sur une cellule pour modifier le niveau de restriction (pays de votre périmètre)',
    en: 'Click a cell to change the restriction level (countries within your scope)',
  },
  'rules.readOnlyHint': {
    fr: 'Consultation seule : la modification est réservée aux administrateurs',
    en: 'Read-only: changes are restricted to administrators',
  },
  'rules.readOnlyRole': {
    fr: 'Lecture seule : modification réservée aux administrateurs',
    en: 'Read-only: changes are restricted to administrators',
  },
  'rules.readOnlyScope': {
    fr: "Lecture seule : pays hors du périmètre de votre organisation",
    en: 'Read-only: country outside your organisation’s scope',
  },
  'rules.activity': { fr: 'Activité', en: 'Activity' },
  'rules.undefined': { fr: 'Non défini', en: 'Not defined' },
  'rules.notConfigured': { fr: 'Pas encore configuré', en: 'Not configured yet' },
  'rules.toConfigure': { fr: 'à configurer', en: 'to configure' },
  'rules.noRules': { fr: 'sans règles', en: 'no rules' },
  'rules.editCell': { fr: 'Modifier : {activity} / {country}', en: 'Edit: {activity} / {country}' },
  'rules.defineCell': {
    fr: '{country} : pas encore de règles définies. Cliquez pour définir.',
    en: '{country}: no rules defined yet. Click to define them.',
  },
  'rules.countryFilter': { fr: 'Pays ({shown}/{total})', en: 'Countries ({shown}/{total})' },
  'rules.pending': { fr: '{n} en cours…', en: '{n} in progress…' },
  'rules.updated': {
    fr: 'Règle mise à jour : {activity} / {country} → {level}',
    en: 'Rule updated: {activity} / {country} → {level}',
  },
  'rules.saveFailed': { fr: "Échec de l'enregistrement : {error}", en: 'Save failed: {error}' },
  'rules.legend': { fr: 'Légende :', en: 'Key:' },
  'rules.legend.allowed': { fr: 'Autorisé', en: 'Allowed' },
  'rules.legend.conditional': { fr: 'Sous conditions', en: 'Conditional' },
  'rules.legend.flagged': { fr: 'Zone grise', en: 'Grey area' },
  'rules.legend.prohibited': { fr: 'Interdit', en: 'Prohibited' },
  'rules.region.all': { fr: 'Tous', en: 'All' },
  'rules.region.other': { fr: 'Autre', en: 'Other' },

  // Libellés d'activité. Le serveur en envoie une version française ; on la
  // remplace ici pour que l'anglais ne reste pas en français.
  'activity.retail': { fr: 'Commerce / E-commerce', en: 'Retail / e-commerce' },
  'activity.food': { fr: 'Alimentation / Livraison', en: 'Food / delivery' },
  'activity.education': { fr: 'Éducation', en: 'Education' },
  'activity.health': { fr: 'Santé / Pharmacie', en: 'Health / pharmacy' },
  'activity.finance': { fr: 'Finance / Prêts', en: 'Finance / lending' },
  'activity.telecom': { fr: 'Télécommunications', en: 'Telecommunications' },
  'activity.travel': { fr: 'Voyage / Transport', en: 'Travel / transport' },
  'activity.gaming': { fr: "Jeux d'argent", en: 'Gambling' },
  'activity.adult': { fr: 'Contenu adulte', en: 'Adult content' },
  'activity.crypto': { fr: 'Crypto-actifs', en: 'Crypto-assets' },
  'activity.other': { fr: 'Autre', en: 'Other' },
} satisfies Bundle
